<div class="host" fxLayout="column" fxLayoutAlign="space-between start">
  <div class="cont-exam-body" fxLayout="column" fxLayoutAlign="start start">
    <div class="banners">
      <img [routerLink]="['/practice-exam']" src="../../../../../assets/img/tamrini.png" class="banner" alt="">
      <img (click)="comingSoon()" src="../../../../../assets/img/roshd.png" class="banner" alt="">
    </div>
  </div>
</div>